<div class="flex items-center gap-2 text-sm font-bold text-white">
  <span>Score:</span>
  @for (dot of scoreDots; track $index) {
    <div
      class="h-4 w-4 rounded-full"
      [ngClass]="getGradientColor(dot)"></div>
  }
</div>
